export const IS_LOADING = "IS_LOADING";
export const SET_DATA = "SET_DATA";
export const RESET_DATA = "RESET_DATA";
export const SET_STEP = "SET_STEP";
export const SET_DIALOG = "SET_DIALOG";
export const SET_PAYMENT_DIALOG = "SET_PAYMENT_DIALOG";
export const SET_CURLEC_BANK_DATA = "SET_CURLEC_BANK_DATA";
